import { useRef } from "react";
import { QRCodeCanvas } from "qrcode.react";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogTrigger, DialogDescription } from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import { Share2, Copy, Download } from "lucide-react";
import { toast } from "sonner";

export default function RiderShareDialog({ url, title }) {
  const ref = useRef(null);
  const copy = async () => {
    try { await navigator.clipboard.writeText(url); toast.success("Link copied"); }
    catch { toast.message("Share link", { description: url }); }
  };
  const nativeShare = async () => {
    if (navigator.share) {
      try { await navigator.share({ title: title || "VeloPaths bike path", text: `Check out ${title} on VeloPaths`, url }); return; }
      catch { /* user cancelled */ return; }
    }
    copy();
  };
  const download = () => {
    const canvas = ref.current?.querySelector("canvas");
    if (!canvas) return;
    const a = document.createElement("a");
    a.href = canvas.toDataURL("image/png");
    a.download = `velopaths-${(title || "path").replace(/\s+/g, "-").toLowerCase()}.png`;
    a.click();
  };
  return (
    <Dialog>
      <DialogTrigger asChild>
        <button data-testid="rider-share" aria-label="Share"
          className="absolute top-4 right-4 w-9 h-9 rounded-full bg-black/50 backdrop-blur flex items-center justify-center text-white active:scale-95">
          <Share2 className="w-4 h-4" />
        </button>
      </DialogTrigger>
      <DialogContent className="max-w-sm" data-testid="rider-share-dialog">
        <DialogHeader>
          <DialogTitle>Share this bike path</DialogTitle>
          <DialogDescription className="truncate">{title}</DialogDescription>
        </DialogHeader>
        <div ref={ref} className="flex justify-center py-3 bg-white rounded-lg" data-testid="rider-share-qr"><QRCodeCanvas value={url} size={200} marginSize={2} /></div>
        <div className="text-xs text-muted-foreground break-all bg-secondary rounded p-2" data-testid="rider-share-url">{url}</div>
        <div className="grid grid-cols-3 gap-2">
          <Button variant="default" onClick={nativeShare} data-testid="rider-share-native"><Share2 className="w-4 h-4 mr-1" />Share</Button>
          <Button variant="outline" onClick={copy} data-testid="rider-share-copy"><Copy className="w-4 h-4 mr-1" />Copy</Button>
          <Button variant="outline" onClick={download} data-testid="rider-share-download"><Download className="w-4 h-4 mr-1" />QR</Button>
        </div>
      </DialogContent>
    </Dialog>
  );
}
